import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Parse estrito por formato depende do plugin; extend é idempotente.
dayjs.extend(customParseFormat);

// O compromisso pessoal trafega data e hora em campos separados: date em
// DD/MM/YYYY e startTime/endTime em HH:mm. Parseamos de forma estrita nesses
// formatos e caímos para o parse padrão do dayjs (ISO) quando o backend devolver
// o valor já normalizado. Retorna null quando o valor é vazio ou inválido.
export const parsePersonalEventDateTime = (date, time) => {
  if (!date) return null;

  const day = dayjs(date, 'DD/MM/YYYY', true);
  const parsedDay = day.isValid() ? day : dayjs(date);
  if (!parsedDay.isValid()) return null;

  if (!time) return parsedDay.startOf('day');

  const parsedTime = dayjs(time, ['HH:mm:ss', 'HH:mm'], true);
  if (!parsedTime.isValid()) return parsedDay.startOf('day');

  return parsedDay.hour(parsedTime.hour()).minute(parsedTime.minute()).second(0);
};

export const PERSONAL_EVENT_COLOR = '#6f42c1';

// Converte um compromisso pessoal em um evento do FullCalendar.
export const toPersonalEvent = (personalEvent) => {
  const start = parsePersonalEventDateTime(personalEvent.date, personalEvent.startTime);
  const end = parsePersonalEventDateTime(personalEvent.date, personalEvent.endTime);

  return {
    title: personalEvent.description || 'Compromisso pessoal',
    start: start ? start.toDate() : null,
    end: end ? end.toDate() : null,
    backgroundColor: PERSONAL_EVENT_COLOR,
    borderColor: PERSONAL_EVENT_COLOR,
    extendedProps: {
      personalEventId: personalEvent.id,
      isPersonalEvent: true,
    },
  };
};
